import { localStorageGetItem, localStorageSetItem } from 'entrypoints/storage_helpers';

const STORAGE_KEY = 'HomepageSurveyAnswers';

export function getAnswersFromStorage() {
  const sessionAnswers = localStorageGetItem(STORAGE_KEY);
  if (!sessionAnswers) {
    return {};
  }

  return JSON.parse(sessionAnswers);
}

export function storeAnswerToStorage(key, val) {
  const currentSessionAnswers = getAnswersFromStorage();
  currentSessionAnswers[key] = val;
  localStorageSetItem(STORAGE_KEY, JSON.stringify(currentSessionAnswers));
}

export function clearAnswersInStorage() {
  localStorageSetItem(STORAGE_KEY, JSON.stringify({}));
}
